/**
 * DJ Press Play - Brand-specific JavaScript
 * Custom UI enhancements
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Only run on DJ Press Play brand pages
    if (!document.documentElement.hasAttribute('data-brand') ||
        document.documentElement.getAttribute('data-brand') !== 'djpressplay') {
      return;
    }

    // Add custom functionality here
    console.log('DJ Press Play brand JS loaded');
  }

})();

